import { t } from '@getaccept/lib-shared/src/helpers/translation.helper';
import type { LocaleObject } from 'yup';

export const yupLocalizationKeys: LocaleObject = {
  mixed: {
    default: args => t('yup_mixed_default', args),
    required: args => t('yup_mixed_required', args),
    defined: args => t('yup_mixed_defined', args),
    notNull: args => t('yup_mixed_notNull', args),
    oneOf: args => t('yup_mixed_oneOf', args),
    notOneOf: args => t('yup_mixed_notOneOf', args),
  },
  string: {
    length: args => t('yup_string_length', args),
    min: args => t('yup_string_min', args),
    max: args => t('yup_string_max', args),
    matches: args => t('yup_string_matches', args),
    email: args => t('yup_string_email', args),
    url: args => t('yup_string_url', args),
    lowercase: args => t('yup_string_lowercase', args),
    uppercase: args => t('yup_string_uppercase', args),
  },
  number: {
    min: args => t('yup_number_min', args),
    max: args => t('yup_number_max', args),
    lessThan: args => t('yup_number_lessThan', args),
    moreThan: args => t('yup_number_moreThan', args),
    positive: args => t('yup_number_positive', args),
    negative: args => t('yup_number_negative', args),
    integer: args => t('yup_number_integer', args),
  },
  date: {
    min: args => t('yup_number_min', args),
    max: args => t('yup_number_max', args),
  },
  boolean: {
    isValue: ({ value }) =>
      value ? t('yup_boolean_isValue_true') : t('yup_boolean_isValue_false'),
  },
  array: {
    min: args => t('yup_array_min', args),
    max: args => t('yup_array_max', args),
    length: args => t('yup_array_length', args),
  },
};
